import { render, staticRenderFns } from "./SubmissionDetails.vue?vue&type=template&id=8445a6f2&"
import script from "./SubmissionDetails.vue?vue&type=script&lang=js&"
export * from "./SubmissionDetails.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionDetails.vue?vue&type=style&index=0&id=8445a6f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports